const datosPaginacion = {
  pageSize: 0,
  totalPage: 0,
  tablaBody: "",
  prestacionesPP: [],
};

export default datosPaginacion;



// WEBPACK FOOTER //
// ./src/components/PaginacionV2/state.js